import React, { forwardRef, ComponentProps } from 'react';

import theme from '@adsk/alloy-react-theme';

import Icon, { IconWithRender } from './Icon';
import { VIEWBOXES } from '../consts';

const AIAssistantIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  ({ size = 24, ...props }, ref) => {
    const use16px = size <= 16;

    return (
      <Icon
        data-testid="AIAssistant"
        ref={ref}
        size={size}
        viewBox={use16px ? VIEWBOXES._16 : VIEWBOXES._24}
        {...props}
      >
        {use16px ? (
          <>
            <path
              fill="currentColor"
              d="M13.9125 11.3911c.4448-.2774 1.0307-.1418 1.3086.3027l.0479.085c.2125.4319.0663.9629-.3506 1.2236l-1.2383.7705-.0107.0069c-.4172.2604-.9589.1579-1.2539-.2227l-.0557-.0791c-.2606-.417-.1575-.9587.2227-1.2539l.08-.0557 1.2393-.7695.0107-.0078Zm.5254-9.1416c.4318-.21253.9628-.06778 1.2237.34863l.0478.08496c.1986.40322.0855.8934-.2695 1.16895l-.0801.05566-13.71581 8.3936c-.41704.2606-.958748.1585-1.253903-.2217l-.055664-.0801c-.2778505-.4449-.142138-1.0316.302734-1.3096L14.353 2.29637l.0849-.04687Zm-7.48434-.10742c.44427-.27493 1.02723-.13948 1.30469.30371.27803.44494.14319 1.03154-.30176 1.30957l-.0039.00195L1.7729 7.49364l-.00098-.00098c-.41635.25701-.953922.15511-1.248044-.22363l-.055664-.08008C.19051 6.74409.325242 6.15737.76997 5.87938l.003906-.00195L6.95356 2.14208Z"
            />
            <path
              fill="url(#b16)"
              d="M14.4385 6.64457c.4319-.2124.9629-.06725 1.2236.34961l.0478.08496c.1985.40319.0855.89347-.2695 1.16895l-.0801.05566-9.16054 5.54685c-.41712.2606-.95785.1578-1.25293-.2226l-.05566-.0791c-.27801-.4449-.14311-1.0315.30175-1.3096l9.16058-5.54688.085-.04785Z"
            />
            <defs>
              <linearGradient
                id="b16"
                x1="14.7137"
                x2="6.67761"
                y1="9.89113"
                y2="13.4815"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="currentColor" stopOpacity=".6" />
                <stop
                  offset=".5"
                  stopColor={theme.tokens.colors.icon.tertiary.value}
                  stopOpacity=".25"
                />
                <stop
                  offset="1"
                  stopColor={theme.tokens.colors.icon.tertiary.value}
                  stopOpacity=".1"
                />
              </linearGradient>
            </defs>
          </>
        ) : (
          <>
            <g clipPath="url(#a24)">
              <path
                fill="url(#b24)"
                d="M8.51131 19.6891c-.45666.2853-1.05817.1464-1.34351-.3103-.28534-.4566-.14645-1.0581.31021-1.3435L19.6595 10.424c.4567-.2854 1.0582-.1465 1.3435.3102.2853.4566.1464 1.0582-.3102 1.3435L8.51131 19.6891Z"
              />
              <path
                fill="url(#c24)"
                d="M7.1678 19.3788c-.28534-.4566-.14645-1.0581.31021-1.3435L19.6595 10.424c.4567-.2854 1.0582-.1465 1.3435.3102.2853.4566.1464 1.0582-.3102 1.3435L8.51131 19.6891c-.45666.2853-1.05817.1464-1.34351-.3103Z"
              />
              <path
                fill="currentColor"
                d="M15.6835 4.22158c.2854.45666.1465 1.05817-.3102 1.34352l-13.76919 8.604c-.45666.2853-1.058172.1464-1.343522-.3102-.2853493-.4567-.146479-1.0582.310176-1.3435L14.34 3.91141c.4566-.28535 1.0582-.14648 1.3435.31017Zm7.5425.20111c.2853.45666.1464 1.05817-.3102 1.34352L1.9386 18.8742c-.45666.2854-1.058172.1465-1.343522-.3102-.285349-.4566-.146479-1.0581.310176-1.3435L21.8824 4.11251c.4567-.28534 1.0582-.14647 1.3436.31018Zm-.1172 4.99566c.2853.45666.1465 1.05815-.3102 1.34355l-2.1059 1.3159c-.4567.2854-1.0582.1465-1.3436-.3102-.2853-.4566-.1464-1.0581.3102-1.3435l2.106-1.31592c.4566-.28535 1.0581-.14648 1.3435.31017Zm.6302 4.36995c.2854.4567.1465 1.0582-.3101 1.3435l-7.5528 4.7195c-.4566.2853-1.0581.1465-1.3435-.3102-.2853-.4566-.1465-1.0582.3102-1.3435l7.5527-4.7195c.4567-.2853 1.0582-.1464 1.3435.3102Zm-.4072 4.9524c.2854.4566.1465 1.0581-.3101 1.3435l-.0068.0042c-.4566.2854-1.0581.1465-1.3435-.3101-.2854-.4566-.1465-1.0582.3101-1.3435l.0068-.0043c.4566-.2853 1.0582-.1465 1.3435.3102Z"
              />
            </g>
            <defs>
              <linearGradient
                id="b24"
                x1="19.7542"
                x2="9.47019"
                y1="14.5684"
                y2="19.1408"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="currentColor" stopOpacity=".6" />
                <stop
                  offset=".5"
                  stopColor={theme.tokens.colors.icon.tertiary.value}
                  stopOpacity=".25"
                />
                <stop
                  offset="1"
                  stopColor={theme.tokens.colors.icon.tertiary.value}
                  stopOpacity=".1"
                />
              </linearGradient>
              <linearGradient
                id="c24"
                x1="19.7542"
                x2="9.47019"
                y1="14.5684"
                y2="19.1408"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="currentColor" stopOpacity=".6" />
                <stop
                  offset=".5"
                  stopColor={theme.tokens.colors.icon.tertiary.value}
                  stopOpacity=".25"
                />
                <stop
                  offset="1"
                  stopColor={theme.tokens.colors.icon.tertiary.value}
                  stopOpacity=".1"
                />
              </linearGradient>
              <clipPath id="a24">
                <path
                  fill={theme.tokens.colors.background.primary.value}
                  d="M0 0h24v24H0z"
                />
              </clipPath>
            </defs>
          </>
        )}
      </Icon>
    );
  },
) as IconWithRender;

AIAssistantIcon.displayName = 'AIAssistantIcon';
AIAssistantIcon.renderIcon = (props) => <AIAssistantIcon {...props} />;
export default AIAssistantIcon;
